"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDetectedItemType = isDetectedItemType;
function isDetectedItemType(itemType) {
    return itemType?.generationType === 'detected';
}
//# sourceMappingURL=item.detected.guard.js.map